// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/styles/PatientDetailsForms.scss
// module id = 1498
// module chunks = 0